import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductComponent } from 'src/@omnial/pages/product/product.component';
import { ProductDetail } from 'src/@omnial/_models/catalog/product.model';

@Component({
    selector: 'app-afterpay-dialog',
    templateUrl: './../../../app/shared/afterpay-dialog/afterpay-dialog.component.html',
    styleUrls: ['./../../../app/shared/afterpay-dialog/afterpay-dialog.component.scss'],
    standalone: false
})
export class AfterpayDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { product: ProductDetail, content: string }) { }

  public close(): void {
    this.dialogRef.close();
  }
}
